import { ItemsTemplate } from '@client/components/cart/items.tsx';
import CartSummary from '@client/components/cart/cart-summary.tsx';
import { CartContext } from '@r/context/cart-context.ts';
import { useContext } from 'react';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { Alert, AlertTitle } from '@ui/alert.tsx';
import { TriangleAlert } from 'lucide-react';
import { useCartHealthcheck } from '@client/hooks/use-cart-healthcheck.ts';

const Cart = () => {
  const { t } = useTranslation();
  const { cartWithTotals: cart } = useContext(CartContext);
  const { healthcheckFailed, invalidProductIris, isCartValid, isCheckingCart } = useCartHealthcheck(
    cart.items
  );

  return (
    <>
      {cart.items?.length ? (
        <div className="space-y-5">
          {!isCartValid && (
            <Alert variant="destructive">
              <div className="flex items-center gap-2">
                <TriangleAlert className="size-4 shrink-0" />
                <AlertTitle className="mb-0 leading-normal">
                  {t('cart.error.stock.insufficient')}
                </AlertTitle>
              </div>
            </Alert>
          )}

          {healthcheckFailed && (
            <Alert variant="destructive">
              <div className="flex items-center gap-2">
                <TriangleAlert className="size-4 shrink-0" />
                <AlertTitle className="mb-0 leading-normal">
                  {t('order.error.stock.verification')}
                </AlertTitle>
              </div>
            </Alert>
          )}

          <div className="grid grid-cols-1 lg:grid-cols-[1fr_400px] gap-x-5 gap-y-10">
            <div className="flex flex-col gap-y-4">
              <ItemsTemplate cart={cart} invalidProductIris={invalidProductIris} />
            </div>

            <div className="relative">
              <div className="flex flex-col gap-y-4">
                <CartSummary
                  context="cart"
                  cart={cart}
                  hasInvalidItems={!isCartValid}
                  isCheckingCart={isCheckingCart}
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center gap-6 py-12 text-center grow">
          <div className="text-2xl font-medium">{t('cart.empty.title')}</div>
          <p className="max-w-md text-gray-600">{t('cart.empty.description')}</p>
          <Link
            to="/shops"
            className="px-6 py-3 text-white transition-colors rounded-md bg-primary hover:bg-primary/90"
          >
            {t('cart.empty.action.view.shops')}
          </Link>
        </div>
      )}
    </>
  );
};

export { Cart };
